import { render } from "./SnapshotManagement.vue?vue&type=template&id=5f733011&scoped=true"
import script from "./SnapshotManagement.vue?vue&type=script&lang=js"
export * from "./SnapshotManagement.vue?vue&type=script&lang=js"

import "./SnapshotManagement.vue?vue&type=style&index=0&id=5f733011&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f733011"]])

export default __exports__